<template>
  <b-collapse
    :id="id"
    :visible="visible"
    :accordion="accordion"
    test-id="al-collapse"
    @input="updateValue"
  >
    <slot />
  </b-collapse>
</template>

<script>
import { BCollapse } from 'bootstrap-vue';

export default {
  components: {
    BCollapse
  },
  model: {
    prop: 'visible'
  },
  props: {
    id: {
      type: String,
      required: true
    },
    accordion: {
      type: String,
      default: ''
    },
    visible: Boolean,
    model: Boolean
  },
  methods: {
    updateValue(visible) {
      this.$emit('input', visible);
    }
  }
};
</script>
